export default __webpack_public_path__ + "e216b9bad508c565a18b814953acd1e0.png";